'use strict';

var React = require('react');

var SvgCircleDisabledMajor = function SvgCircleDisabledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 10c0-1.846.635-3.543 1.688-4.897l11.209 11.209a7.954 7.954 0 0 1-4.897 1.688c-4.411 0-8-3.589-8-8zm14.312 4.897-11.209-11.209a7.954 7.954 0 0 1 4.897-1.688c4.411 0 8 3.589 8 8a7.952 7.952 0 0 1-1.688 4.897zm-16.312-4.897c0 5.514 4.486 10 10 10s10-4.486 10-10-4.486-10-10-10-10 4.486-10 10z"
  }));
};

exports.SvgCircleDisabledMajor = SvgCircleDisabledMajor;
